/** Pad month/day to two digits. */
function pad2(n) {
  return String(n).padStart(2, "0");
}

/**
 * Local calendar YYYY-MM-DD for pond session datetimes.
 * Bare YYYY-MM-DD (no time) stays literal; ISO datetimes use the browser's local day
 * so evening samples do not collapse onto the next UTC calendar day.
 */
function toLocalSessionYmd(date) {
  if (date == null || date === "") return null;

  if (typeof date === "string") {
    const s = date.trim();
    // Date-only (no time component) — keep the literal calendar day.
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  }

  const d =
    date instanceof Date && !Number.isNaN(date.getTime())
      ? date
      : new Date(date);
  if (Number.isNaN(d.getTime())) return null;

  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

export function formatTick(value) {
  if (Number.isInteger(value)) return value.toFixed(1).toString();
  return value.toFixed(2).replace(/\.?0+$/, "");
}

export function formatLengthTick(value, unitValue) {
  if (Number.isInteger(value))
    return unitValue === "English"
      ? value.toFixed(1).toString()
      : value.toFixed(0).toString();
  return value.toFixed(2).replace(/\.?0+$/, "");
}

/** YYYY-MM-DD for API / sort keys — not for user display. */
export function formatDate(date) {
  return toLocalSessionYmd(date);
}

/** User-facing date: MM/DD/YYYY (local session calendar day). */
export function formatDateTime(dateString) {
  if (!dateString && dateString !== 0) return "N/A";
  try {
    const ymd = toLocalSessionYmd(dateString);
    if (!ymd) return "N/A";
    const [y, m, d] = ymd.split("-").map(Number);
    const local = new Date(y, m - 1, d);
    if (Number.isNaN(local.getTime())) return "N/A";
    return local.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  } catch {
    return "N/A";
  }
}
